const regExpObj = {
  positiveInteger: /^[1-9]\d*$/,
  positiveIntegerAndZero: /^[+]{0,1}(\d+)$/,
  phone: /^1\d{10}$/, // 手机号正则
  idCard: /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/, // 身份证号码
  socialCreditCode: /[0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10}/,
  socialCreditCode2: /^\S{18}$/,
  username: /^[\u4e00-\u9fa5]{2,7}$/ // 姓名，校验2~7个汉字
};

export default regExpObj;
